import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type SendOtpForUpdatingUserPinMutationVariables = Types.Exact<{
   params: Types.SendOtpForUpdatingUserPinParams
}>

export type SendOtpForUpdatingUserPinMutation = {
   __typename?: 'Mutation'
   sendOtpForUpdatingUserPin:
      | { __typename?: 'NoRegisteredMobileNumber'; message?: string | null }
      | { __typename?: 'SendOtpForUpdatingUserPinResult'; success: boolean }
}

export const SendOtpForUpdatingUserPinDocument = gql`
   mutation SendOtpForUpdatingUserPin(
      $params: SendOtpForUpdatingUserPinParams!
   ) {
      sendOtpForUpdatingUserPin(params: $params) {
         ... on SendOtpForUpdatingUserPinResult {
            success
         }
         ... on NoRegisteredMobileNumber {
            message
         }
      }
   }
`
export type SendOtpForUpdatingUserPinMutationFn = Apollo.MutationFunction<
   SendOtpForUpdatingUserPinMutation,
   SendOtpForUpdatingUserPinMutationVariables
>
export type SendOtpForUpdatingUserPinMutationResult = Apollo.MutationResult<
   SendOtpForUpdatingUserPinMutation
>
export type SendOtpForUpdatingUserPinMutationOptions = Apollo.BaseMutationOptions<
   SendOtpForUpdatingUserPinMutation,
   SendOtpForUpdatingUserPinMutationVariables
>
